// extracted by mini-css-extract-plugin
export var deleteIcon = "_rs-5";
export var deleteOption = "_rs-3";
export var divider = "_rs-2";
export var downloadIcon = "_rs-4";
export var drawer = "_rs-0";
export var drawerFooter = "_rs-6";
export var drawerOpen = "_rs-1";
export var highlighted = "_rs-7";
export var lighterHighlight = "_rs-8";